export const mutationsStudio = {
    setLoading(state, payload) {
        state.loading = payload
    },
    setStudio(state, payload) {
        state.studio = payload
    },
}
